import polylineTool from '@mapbox/polyline';

export type DecodedPolyline = [number, number][];

const convertRoutePolyline = (polyline: string, precision: number): DecodedPolyline => {
  const decodedPolyline = polylineTool.decode(polyline, precision);

  // convert from latLng to lngLat
  return decodedPolyline.map((poly: any) => [poly[1], poly[0]]);
};

export default convertRoutePolyline;
